<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 50px;padding-top: 20px;margin: 0 20px">
      <el-button type="primary" plain icon="el-icon-plus" @click="openAddMed()">用药登记</el-button>
      <el-select v-fixZoom v-model="filterType" placeholder="请选择" style="width: 130px">
        <el-option v-for="item in filterTypeArr" :key="item.value" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-input v-model="filterText" prefix-icon="el-icon-search" placeholder="请输入" clearable style="width: 250px"></el-input>
      <el-button type="success" @click="getSearchData">查询</el-button>
    </div>
    <div style="height: calc(100% - 120px);margin: 0 20px">
      <el-table :data="tableData" border highlight-current-row ref="singleTable" height="100%">
        <el-table-column
          type="index"
          label="序号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="Person_name"
          label="老人姓名"
          min-width="120"
          align="center">
        </el-table-column>
        <el-table-column
          prop="room_name"
          label="房间"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="bed_name"
          label="床位"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="med_name"
          label="药物名称"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          label="周期类型"
          min-width="100"
          align="center">
          <template slot-scope="scope">
            <span>{{getPeriodTypeDesc(scope.row.period_type)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="times_per_period"
          label="周期内次数"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="desc_per_time"
          label="服用方式"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="desc_other"
          label="注意事项"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          label="开始服用时间"
          width="110"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.start_time.split(' ')[0]}}</span>
            <br>
            <span>{{scope.row.start_time.split(' ')[1]}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="结束服用时间"
          width="110"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.end_time.split(' ')[0]}}</span>
            <br>
            <span>{{scope.row.end_time.split(' ')[1]}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          label="状态"
          min-width="100"
          align="center">
          <template slot-scope="scope">
            <span>{{getStatus(scope.row)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="280">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="editOpen(scope.row)">修改</el-button>
            <el-button size="mini" type="danger" plain @click="delOpen(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ addEditTitle }}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-med-person :medPersonObj="medPersonObj" v-model="addEditShow" @updateTable="updateTable"></add-edit-med-person>
    </el-dialog>
  </div>
</template>

<script>
import {querymedpersonlist, updatemedperson} from '../../api/yanglaoyuan/eservice'
import addEditMedPerson from './components/addEditMedPerson'

export default {
  name: 'medicationRegistration',
  components: {addEditMedPerson},
  data () {
    return {
      entityId: 0,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      filterTypeArr: [{id: 1, name: '老人姓名'}, {id: 2, name: '房间名称'}, {id: 3, name: '床位名称'}],
      filterType: 1,
      filterText: '',

      tableData: [],

      addEditTitle: '',
      addEditShow: false,
      medPersonObj: {
        openType: 0,
        row: ''
      }
    }
  },
  created () {
    let loginResp = this.$store.state.user.LoginResp
    this.entityId = loginResp.entity_id
    this.getSearchData()
  },
  methods: {
    getSearchData () {
      this.getMedPersonData()
    },
    updateTable () {
      this.getMedPersonData()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getSearchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getSearchData()
    },

    openAddMed () {
      this.addEditTitle = '用药登记'
      this.medPersonObj.openType = 1
      this.medPersonObj.row = ''
      this.addEditShow = true
    },
    editOpen (row) {
      this.addEditTitle = '修改'
      this.medPersonObj.openType = 2
      this.medPersonObj.row = row
      this.addEditShow = true
    },
    delOpen (row) {
      this.$confirm('此操作将删除该用药记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          oper_type: 2,
          eid: row.eid,
          id: row.id
        }
        updatemedperson(data).then(res => {
          this.$notify({title: '成功', message: '成功删除该用药记录', type: 'success', duration: 2000})
          this.updateTable()
        })
      })
    },

    // table显示
    getPeriodTypeDesc (periodType) {
      let result = ''
      if (periodType === 0) {
        result = '一次'
      } else if (periodType === 1) {
        result = '每天'
      } else if (periodType === 2) {
        result = '每周'
      } else if (periodType === 3) {
        result = '每月'
      } else {
        result = periodType + ''
      }
      return result
    },
    getStatus (row) {
      let result = ''
      let now = new Date().format('yyyy-MM-dd hh:mm:ss')
      if (now < row.start_time) {
        result = '未开始'
      } else if (now <= row.end_time) {
        result = '正在进行'
      } else {
        result = '已过期'
      }
      return result
    },

    // 访问接口
    // 获取用药提醒
    getMedPersonData () {
      this.tableData = []
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        eid: this.entityId,
        elderly_name: this.filterType === 1 ? this.filterText : '',
        room_name: this.filterType === 2 ? this.filterText : '',
        bed_name: this.filterType === 3 ? this.filterText : '',
        active_status: 0
      }
      querymedpersonlist(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.arrdata
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/medicationRegistration.vue